import { useState } from "react";
import axios from "axios";
import { PRIVACY_URL } from "@/lib/i18n";

import { API } from "@/lib/api";
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const WaitlistForm = ({ t, lang }) => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [website, setWebsite] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) return setError("invalidEmail");
    if (!consent) return setError("needConsent");
    setError("");
    setStatus("sending");
    try {
      await axios.post(`${API}/waitlist`, { email: email.trim(), consent, lang, website });
      setStatus("done");
    } catch (err) {
      const code = err.response?.status;
      setError(code === 429 ? "rateLimited" : code === 422 ? "invalidEmail" : "genericError");
      setStatus("idle");
    }
  };

  if (status === "done") {
    return (
      <div className="as-thanks as-fade" role="status" data-testid="waitlist-thanks">
        <p className="as-thanks-title">{t.thanksTitle}</p>
        <p>{t.thanksBody}</p>
      </div>
    );
  }

  return (
    <form className="as-form" onSubmit={submit} noValidate data-testid="waitlist-form">
      <label htmlFor="as-email" className="as-visually-hidden">{t.emailLabel}</label>
      <div className="as-row">
        <input
          id="as-email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder={t.emailPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-invalid={error === "invalidEmail"}
          data-testid="waitlist-email-input"
        />
        <button type="submit" disabled={status === "sending"} data-testid="waitlist-submit-button">
          {status === "sending" ? t.sending : t.join}
        </button>
      </div>

      <div className="as-hp" aria-hidden="true">
        <label htmlFor="as-website">Website</label>
        <input id="as-website" name="website" tabIndex={-1} autoComplete="off" value={website}
          onChange={(e) => setWebsite(e.target.value)} data-testid="waitlist-honeypot-input" />
      </div>

      <label className="as-consent" htmlFor="as-consent">
        <input id="as-consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)}
          data-testid="waitlist-consent-checkbox" />
        <span>
          {t.consentBefore}
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" data-testid="consent-privacy-link">{t.privacy}</a>
          {t.consentAfter}
        </span>
      </label>

      <p className="as-error" role="alert" data-testid="waitlist-error">{error ? t[error] : ""}</p>
    </form>
  );
};
